/**
 * PeriodToggle — Today / Week / Month bar.
 *
 * Plain buttons styled to match the existing pill/tab look in
 * MasterDashboard. Caller passes `period` + `onChange`; the value is
 * round-tripped as the `?period=` query param on the dashboard's
 * fetch call.
 */
const PERIODS = [
  { key: "today", label: "Today" },
  { key: "week", label: "Week" },
  { key: "month", label: "Month" },
];

export function PeriodToggle({ period, onChange }) {
  return (
    <div className="inline-flex border border-border rounded-sm bg-white" data-testid="period-toggle">
      {PERIODS.map((p) => {
        const active = p.key === period;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onChange(p.key)}
            data-testid={`period-${p.key}`}
            className={
              "px-4 py-2 text-xs font-mono uppercase tracking-wider transition-colors " +
              (active
                ? "bg-zinc-900 text-white"
                : "text-zinc-600 hover:bg-zinc-50")
            }
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}

export default PeriodToggle;
